/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PaymentGateway from './payment-gateway';
import PaymentGatewayDetail from './payment-gateway-detail';
import PaymentGatewayUpdate from './payment-gateway-update';
import PaymentGatewayDeleteDialog from './payment-gateway-delete-dialog';

const PaymentGatewayRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PaymentGateway />} />
    <Route path="new" element={<PaymentGatewayUpdate />} />
    <Route path=":id">
      <Route index element={<PaymentGatewayDetail />} />
      <Route path="edit" element={<PaymentGatewayUpdate />} />
      <Route path="delete" element={<PaymentGatewayDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PaymentGatewayRoutes;
